import { render } from "./ModalPreorderActivation.vue?vue&type=template&id=cdb58048"
import script from "./ModalPreorderActivation.vue?vue&type=script&lang=js"
export * from "./ModalPreorderActivation.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__